export const ChangeListResultSearch = (result) => ({
    type: 'CHANGE_LIST_RESULT_SEARCH',result
});
export const ChangeListPageResultSearch = (listResult) => ({
    type: 'CHANGE_LIST_PAGE_RESULT_SEARCH',listResult
});
export const actionChangeTextInputsSearch = (text) => ({
    type: 'CHANGE_TEXT_INPUTS_SEARCH',text
});
export const actionChangeLoaderInputsSearch = (loaderSearch) => ({
    type: 'CHANGE_LOADER_INPUT_SEARCH',loaderSearch
});